var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmloxHubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 262.5 105",
    style: {
      enableBackground: "new 0 0 262.5 105"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.8,
    y: 36.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -9.9029 57.4052)",
    width: 7,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.2,
    y: 59.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -33.5896 47.5945)",
    width: 7,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 32.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -21.7462 52.4998)",
    width: 8.9,
    height: 40.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M198.2,52.4c0-7.2-5.9-13.1-13.1-13.1c-7.2,0-13.1,5.9-13.1,13.1c0,7.2,5.9,13.1,13.1,13.1 C192.3,65.5,198.2,59.6,198.2,52.4L198.2,52.4z M190.4,52.4c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3 c0-2.9,2.4-5.3,5.3-5.3C188,47.1,190.4,49.5,190.4,52.4L190.4,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,52.4c0-7.2-5.9-13.1-13.1-13.1s-13.1,5.9-13.1,13.1c0,7.2,5.9,13.1,13.1,13.1S109.4,59.6,109.4,52.4L109.4,52.4z  M101.6,52.4c0,2.9-2.4,5.3-5.3,5.3S91,55.3,91,52.4c0-2.9,2.4-5.3,5.3-5.3S101.6,49.5,101.6,52.4L101.6,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,64.8h8.8V51.2c0-2.7,1.5-4.2,3.6-4.2c2.1,0,3.4,1.4,3.4,4.2v13.6h8.8V51.2c0-2.7,1.5-4.2,3.6-4.2 c2.1,0,3.4,1.4,3.4,4.2v13.6h8.8V48.4c0-5.8-3.2-9.2-8.6-9.2c-3.7,0-6.2,1.6-8.4,4.1c-1.3-2.6-3.9-4.1-7.2-4.1 c-3.5,0-5.8,1.9-7.5,4v-3.4h-8.8V64.8L113.1,64.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.8,64.8 167.6,64.8 167.6,31 158.8,31 158.8,64.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.5,52.4 227.5,44.4 221.9,38.8 213.9,46.8 205.9,38.8 200.3,44.4 208.3,52.4 200.3,60.4 205.9,66 213.9,58  221.9,66 227.5,60.4 219.5,52.4  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmloxHubLogo);
export default __webpack_public_path__ + "static/media/omlox-hub-logo.3b7dd7610a308b774b254084515c14b8.svg";
export { ForwardRef as ReactComponent };